import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { PrivateRouteProps } from './interfaces';

function PrivateRoute({ children, ...rest }: PrivateRouteProps) {
  return <Route {...rest} render={() => (rest.isAuth ? children : <Redirect to={{ pathname: '/' }} />)} />;
}

export default PrivateRoute;
